import React from "react";
import "./Imprint.css";

const Imprint = () => {
  return (
    <div className="imprint_parent_div">
      <h1>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorum ea
        veniam architecto dolor! Quod blanditiis, aspernatur dolorem ipsam,
        laboriosam repellendus quia iste quo incidunt dolorum iure perferendis
        esse, consequatur dolores.
      </h1>
    </div>
  );
};

export default Imprint;
